import { Canvas, CanvasProps, extend, ThreeToJSXElements } from '@react-three/fiber';
import * as React from 'react';
import * as THREE from 'three/webgpu';

declare module '@react-three/fiber' {
  interface ThreeElements extends ThreeToJSXElements<typeof THREE> {}
}

extend(THREE as any);

export type Props = CanvasProps & {
  children?: React.ReactNode;
};

function WebGpuCanvas(props: Props) {
  const { children, ...rest } = props;

  return (
    <Canvas
      {...rest}
      gl={async (props) => {
        const renderer = new THREE.WebGPURenderer(props as any);
        renderer['capabilities'] = {
          getMaxAnisotropy() {
            return 0;
          },
        };
        await renderer.init();
        return renderer;
      }}
    >
      {children}
    </Canvas>
  );
}

export default WebGpuCanvas;
